import React from 'react';
import { useParams } from 'react-router-dom';
import { Container } from '@mui/material';
import DashboardLayout from '../../../shared/layout/DashboardLayout';
import ValoracionFuncionalViewer from '../components/ValoracionFuncionalViewer';

export default function ValoracionFuncionalDetailPage() {
  const { idTipo, paciente } = useParams();

  return (
    <DashboardLayout>
      <Container maxWidth="100%" sx={{ mt: { xs: 2, md: 4 }, mb: 4, px: { xs: 1, sm: 2 } }}>
        <ValoracionFuncionalViewer idTipo={idTipo} paciente={paciente} />
      </Container>
    </DashboardLayout>
  );
}
